import { render, staticRenderFns } from "./SystemCommunicationsEmailConfigModal.vue?vue&type=template&id=76d7b9ca&scoped=true"
import script from "./SystemCommunicationsEmailConfigModal.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsEmailConfigModal.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunicationsEmailConfigModal.vue?vue&type=style&index=0&id=76d7b9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d7b9ca",
  null
  
)

export default component.exports